<template>
  <div class="drama-home">
    <div class="full-width-banner">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="slide slide-1">
          <img src="../assets/images/banner1.jpg" alt="Technical services and smart hardware business 1" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-2">
          <img src="../assets/images/banner2.jpg" alt="IoT and electronic products business 2" class="banner-image" />
        </swiper-slide>
        <swiper-slide class="slide slide-3">
          <img src="../assets/images/banner3.jpg" alt="Trade agency and cross-border logistics business 3" class="banner-image" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="container">
      <section class="hero panel reveal">
        <div class="hero-copy">
          <p class="tag">Technical Services & Diversified Trading Provider</p>
          <h1>Built on Technology, Connecting R&amp;D, Products and Global Trade</h1>
        <p class="desc">
          Centered on technical services, technical development, technical consulting, technical exchange,
          technology transfer and technology promotion, combined with IoT, AI hardware, electronic products
          and multi-category retail trade, we deliver integrated services from solution design and product
          delivery to channel distribution.
        </p>
      </div>
      <div class="hero-data">
        <div class="data-card">
          <span class="number">Technical Services</span>
          <span class="label">End-to-end coverage of development, consulting, exchange, transfer and promotion</span>
        </div>
        <div class="data-card">
          <span class="number">Smart IoT</span>
          <span class="label">IoT R&amp;D and technical services, delivered together with AI hardware sales</span>
        </div>
        <div class="data-card">
          <span class="number">Global Trade</span>
          <span class="label">Import &amp; export of goods and technology, trade agency and international freight forwarding</span>
        </div>
      </div>
    </section>

    <section class="genres reveal">
      <div class="section-head">
        <p>Business Focus</p>
        <h2>A Business Layout Spanning Technology R&amp;D and Multi-Category Operations</h2>
      </div>
      <div class="genre-grid">
        <article class="genre-item">
          <h3>Technology &amp; Network Services</h3>
          <p>Technical services, technical development, technical consulting, technical exchange, technology transfer and promotion, network technical services, and information technology consulting.</p>
        </article>
        <article class="genre-item">
          <h3>IoT &amp; Artificial Intelligence</h3>
          <p>IoT technology R&amp;D and technical services, AI hardware sales, manufacturing of other electronic devices and sales of electronic products.</p>
        </article>
        <article class="genre-item">
          <h3>Commercial Cryptography Products</h3>
          <p>Production and sales of commercial cryptography products, providing compliant product support for information security scenarios.</p>
        </article>
        <article class="genre-item">
          <h3>Jewelry &amp; Craft Gifts</h3>
          <p>Manufacturing and retail of jewelry, retail of arts, crafts and collectibles (excluding ivory and its products), and sales of gifts and flowers.</p>
        </article>
        <article class="genre-item">
          <h3>Daily Consumer Retail</h3>
          <p>Sales of daily necessities, apparel, outdoor products, lighting fixtures, hardware, auto parts, computer software and hardware and auxiliary equipment, and communication devices.</p>
        </article>
      </div>
    </section>

    <section class="lineup panel reveal">
      <div class="section-head">
        <p>Capabilities</p>
        <h2>A Complete Chain From R&amp;D Delivery to Distribution Fulfillment</h2>
      </div>
      <div class="lineup-list">
        <div class="lineup-item">
          <p class="title">R&amp;D and Technical Delivery</p>
          <p class="meta">With technical services and development at the core, we provide solution consulting, technical exchange and achievement transfer and promotion to support customers' digital upgrading.</p>
        </div>
        <div class="lineup-item">
          <p class="title">Supply Chain &amp; Channels</p>
          <p class="meta">Domestic trade agency, online sales and import &amp; export agency work in synergy to build an efficient distribution network from production to consumption.</p>
        </div>
        <div class="lineup-item">
          <p class="title">Compliance Assurance</p>
          <p class="meta">Operating in compliance with the registration records of the Accounting and Corporate Regulatory Authority (ACRA) of Singapore, with corporate credentials valid on an ongoing basis and verifiable.</p>
        </div>
      </div>
    </section>

    <section class="cta reveal">
      <h2>A Collaboration Platform Driven by Technology, Diverse Categories and Extensive Channels</h2>
      <p>We support technology R&amp;D collaboration, product supply, channel agency and cross-border trade, helping partners achieve steady growth.</p>
    </section>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
};
</script>

<style scoped>
.drama-home {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding-bottom: 26px;
}

.full-width-banner {
  width: 100%;
  height: 80vh;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 20px;
}

.slide {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #11212b; /* placeholder color */
  position: relative;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.container {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  gap: 26px;
  padding: 0 24px;
}

.panel {
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 20px;
  background: rgba(7, 14, 20, 0.72);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.3);
}

.hero {
  padding: 32px;
  display: grid;
  gap: 22px;
  grid-template-columns: 1.25fr 1fr;
}

.hero-copy {
  display: grid;
  align-content: start;
  gap: 8px;
}

.tag {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #ffb684;
}

h1 {
  margin: 14px 0;
  font-size: clamp(34px, 5vw, 56px);
  line-height: 1.08;
}

.desc {
  margin: 0;
  max-width: 620px;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.82);
}

.btn {
  border: 0;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.btn-solid {
  color: #fff;
  background: linear-gradient(110deg, #ff6f2c, #ff9259);
}

.hero-data {
  display: grid;
  gap: 12px;
  align-content: center;
}

.data-card {
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.number {
  display: block;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 800;
}

.label {
  color: rgba(236, 245, 250, 0.75);
  font-size: 13px;
}

.genres,
.lineup,
.cta {
  padding: 26px;
}

.section-head p {
  margin: 0;
  color: #ffb684;
  letter-spacing: 0.1em;
  font-size: 12px;
  text-transform: uppercase;
}

.section-head h2 {
  margin: 10px 0 18px;
  font-size: clamp(24px, 3vw, 34px);
}

.genre-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.genre-item {
  padding: 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.genre-item h3 {
  margin: 0 0 8px;
  font-size: 16px;
}

.genre-item p,
.lineup-item .meta,
.cta p {
  margin: 0;
  line-height: 1.7;
  color: rgba(236, 245, 250, 0.78);
}

.lineup-list {
  display: grid;
  gap: 12px;
}

.lineup-item {
  padding: 16px;
  border-radius: 14px;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.12), rgba(255, 255, 255, 0.06));
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.lineup-item .title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
}

.cta {
  border-radius: 20px;
  text-align: center;
  background: linear-gradient(120deg, rgba(255, 111, 44, 0.18), rgba(10, 40, 60, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.cta h2 {
  margin-top: 0;
}

.cta .btn {
  margin-top: 14px;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  animation: rise 0.7s ease forwards;
}

.reveal:nth-child(2) {
  animation-delay: 0.1s;
}

.reveal:nth-child(3) {
  animation-delay: 0.2s;
}

.reveal:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes rise {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 1060px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .genre-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .hero,
  .genres,
  .lineup,
  .cta {
    padding: 22px;
  }

  .genre-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .drama-home {
    gap: 24px;
    padding-bottom: 18px;
  }

  .full-width-banner {
    height: 52vh;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 36px;
    height: 36px;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 14px;
  }

  .swiper-pagination {
    bottom: 4px;
  }

  .container {
    gap: 18px;
    padding: 0 14px;
  }

  .hero {
    padding: 18px;
    gap: 16px;
  }

  h1 {
    margin: 10px 0;
    font-size: clamp(24px, 6.4vw, 32px);
    line-height: 1.25;
  }

  .desc {
    font-size: 14px;
    line-height: 1.75;
  }

  .tag {
    font-size: 11px;
    letter-spacing: 0.12em;
  }

  .data-card {
    padding: 14px;
  }

  .number {
    font-size: 17px;
  }

  .label {
    font-size: 12px;
  }

  .genres,
  .lineup,
  .cta {
    padding: 18px;
  }

  .section-head h2 {
    margin: 8px 0 14px;
    font-size: clamp(19px, 5vw, 24px);
  }

  .genre-item,
  .lineup-item {
    padding: 12px;
  }

  .genre-item h3 {
    font-size: 15px;
  }

  .genre-item p,
  .lineup-item .meta,
  .cta p {
    font-size: 13px;
    line-height: 1.75;
  }

  .lineup-item .title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .full-width-banner {
    height: 44vh;
  }

  .container {
    gap: 14px;
  }

  .hero {
    padding: 16px;
  }

  .cta h2 {
    font-size: 19px;
  }
}
</style>
